module.exports = __webpack_public_path__ + "img/icon-code.64009fb7.svg";